import {
  Home,
  Star,
  CreditCard,
  Info,
  Mail,
  HelpCircle,
  Users,
  CreditCard as Payment,
  Truck,
} from 'lucide-react'

interface NavigationItem {
  href?: string
  label: string
  icon?: React.ComponentType<{ className?: string }>
  children?: NavigationItem[]
}

export const NAVIGATION_ITEMS: NavigationItem[] = [
  { href: '/', label: 'Startseite', icon: Home },
  {
    label: 'Produkte',
    icon: CreditCard,
    children: [
      { href: '/produkte', label: 'Produktübersicht' },
      { href: '/alle-produkte', label: 'Alle Produkte' },
    ],
  },
  { href: '/kategorien', label: 'Kategorien', icon: Info },
  { href: '/anlaesse', label: 'Anlässe', icon: Star },
  {
    label: 'Informationen',
    icon: Mail,
    children: [
      { href: '/kontakt', label: 'Kontakt', icon: Mail },
      { href: '/faq', label: 'FAQ', icon: HelpCircle },
      { href: '/ueber-uns', label: 'Über Uns', icon: Users },
      { href: '/zahlungsarten', label: 'Zahlungsarten', icon: Payment },
      { href: '/versand', label: 'Versandmethoden', icon: Truck },
    ],
  },
]

export const DESKTOP_NAVIGATION_ITEMS: NavigationItem[] = [
  {
    label: 'Produkte',
    children: [
      { href: '/produkte', label: 'Produktübersicht' },
      { href: '/alle-produkte', label: 'Alle Produkte' },
    ],
  },
  { href: '/kategorien', label: 'Kategorien' },
  { href: '/anlaesse', label: 'Anlässe' },
  {
    label: 'Informationen',
    children: [
      { href: '/kontakt', label: 'Kontakt' },
      { href: '/faq', label: 'FAQ' },
      { href: '/ueber-uns', label: 'Über Uns' },
      { href: '/zahlungsarten', label: 'Zahlungsarten' },
      { href: '/versand', label: 'Versandmethoden' },
    ],
  },
]
